<template>
  <div class="c-range-chart">
    <span class="sr-only">{{ getAriaText(params) }}</span>
    <span
      ><slot name="start">{{ start }}</slot></span
    >
    <div class="c-range-chart__container">
      <span class="c-range-chart__bar c-range-chart__bar--positive" :style="{ width: startPCT + '%' }" />
      <span class="c-range-chart__bar c-range-chart__bar--negative" :style="{ width: endPCT + '%' }" />
    </div>
    <span
      ><slot name="end">{{ end }}</slot></span
    >
  </div>
</template>

<script>
import { getAriaText } from '@utils/helpers';
export default {
  name: 'c-range-chart',
  props: {
    start: {
      required: true,
      type: Number
    },
    end: {
      required: true,
      type: Number
    },
    mark: {
      required: true,
      type: Number
    },
    params: {
      required: true,
      type: Object
    }
  },
  computed: {
    startPCT() {
      return ((this.mark - this.start) / (this.end - this.start)) * 100;
    },
    endPCT() {
      return 100 - this.startPCT;
    }
  },
  methods: {
    getAriaText
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-range-chart';
</style>
